/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { Form, Col, Row, Table, Button, Skeleton } from "antd";
import type { UploadProps } from "antd/es/upload/interface";
import { CreateModal } from "./create-modal";
import { useEffect, useState } from "react";
import type { ColumnsType } from "antd/es/table";
import { Routes } from "../../../../../../AppRoutes";
import { useHistory, useRouteMatch } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { Upload, DatePicker, Checkbox, Modal } from "antd";
import { IMaterialType } from "../../models";
import { downloadExcel } from "react-export-table-to-excel";
import moment from "moment";
import { EditModal } from "./edit-modal";
import { HOSummaryEmployeeRequestService } from "../../../../../../services/human-organization/summary-employee-request.service";
import { StyledButton, StyledTitle } from "../../../../../../components/styled-antd";
import ExcelJS from "exceljs";
import { additionalFormFields, eContentFields } from "../../constant/field-names";
import { formFields } from "../../constant/field-names";
import { RenderHelper } from "../../utils/render-helper";
import { requestStatus } from "../../../../../../constants";
import { HiOutlineTrash } from "react-icons/hi2";
import _ from "lodash";

const { RangePicker } = DatePicker;

export function EditForm() {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const history = useHistory();
  const [fileList, setFileList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const [form] = Form.useForm();
  const { id } = useRouteMatch().params as any;
  const [isFinish, setIsFinish] = useState(false);
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [listDelete, setListDelete] = useState<number[]>([]);

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      form.setFieldsValue({
        eApprovedBy: null,
        pickedUser: null,
      });
    }
  };

  const columns: ColumnsType<IMaterialType> = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, dataSource.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (value: any, record: IMaterialType, index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter((value): any => value != index);
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="d-flex">
            <EditModal dataSource={dataSource} setDataSource={setDataSource} index={index} />

            <Button
              onClick={() => {
                const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
                if ((dataSource.length - 1) % 10 == 0) {
                  if (currentPage >= 2 && currentPage === NUM_PAGES) setCurrentPage(currentPage - 1);
                }

                setDataSource((prev) => {
                  return prev.filter((value, indexValue) => indexValue != index);
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash size={20} className="cursor-pointer" color="#dc2626" />
            </Button>
          </div>
        );
      },
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: IMaterialType, index: number) => <>{(currentPage - 1) * pageSize + index + 1}</>,
    },
    ...eContentFields.map((value, index) => {
      return {
        title: value.label,
        dataIndex: value.field,
        key: value.field,
      };
    }),
  ];

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: async (file) => {
      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet, sheetId) => {
          sheet.eachRow((row: any, rowIndex) => {
            data.push(row.values.filter((value: any, index: number) => index != 0));
          });
        });

        data = data.filter((value, index) => index != 0);
        const dataSource: any[] = [];

        for (const item of data) {
          let isValid = true;

          if (!Array.isArray(item) || item.length != eContentFields.length) {
            isValid = false;
          }

          // eContentFields.forEach((value, index) => {
          //   if (value.field === "email") {
          //     if (!item[index].text) {
          //       isValid = false
          //     }
          //   }
          // });

          if (!isValid) {
            CreateNotification({
              title: "Import file thất bại",
              body: `Vui lòng download biểu mẫu và nhập đúng thông tin.`,
              icon: "/icons/error.png",
            });
            return;
          }

          const record: any = {};
          eContentFields.forEach((value, index) => {
            if (value.field === "email") {
              record[value.field] = item[index]?.text || item[index];
            } else {
              record[value.field] = item[index];
            }
          });

          dataSource.push(record);
        }
        setDataSource((prev) => [...prev, ...dataSource]);
        setFileList([...fileList, file]);
      };

      return false;
    },
    fileList,
    showUploadList: false,
  };

  const onFinish = async (values: any) => {
    // if (dataSource.length === 0) {
    //   CreateNotification({
    //     title: "Thất bại",
    //     body: `Vui lòng nhập các thông tin yêu cầu`,
    //     icon: "/icons/error.png",
    //   });
    //   return;
    // }

    try {
      let initFields: any = {
        eCourse: values.eCourse,
        eCourseDate: values.eCourseDate[0],
        eContent: JSON.stringify(dataSource),
        eCourseDateEnd: values.eCourseDate[1],
      };

      formFields.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      additionalFormFields.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      // const resp = await HOSummaryEmployeeRequestService.updateSummaryEmployeeRequest(id, initFields);

      CreateNotification({
        title: "Thành công",
        body: `Chỉnh sửa yêu cầu thành công`,
        icon: "/icons/success.png",
      });
      history.push(Routes.summaryEmployeeRequestPage.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Chỉnh sửa yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
      history.push(Routes.summaryEmployeeRequestPage.path);
    }
  };

  const downLoad = () => {
    const header = [
      "Tên vật tư/hàng hóaNhân sự/ mã NV đã đăng ký	",
      "Nhân sự/ mã NV thay thế/ bổ sung	",
      "Cơ quan/ Đơn vị",
      "Lý do thay đổi",
      "Ghi chú",
    ];
    const body: any[] = [];

    downloadExcel({
      fileName: "PHIẾU THAY ĐỔI/ BỔ SUNG NHÂN SỰ KHÓA HỌC ",
      sheet: "1",
      tablePayload: {
        header,
        // accept two different data structures
        body: body,
      },
    });
  };

  const [allValue, setAllValue] = useState({});

  const initialData = async () => {
    setLoading(true);
    const data = await HOSummaryEmployeeRequestService.getDetailsSummaryEmployeeRequest(id);
    setLoading(false);

    setDataSource(JSON.parse(data.fields.eContent));

    setAllValue({
      eCourse: data.fields.eCourse,
      eMajor: data.fields.eMajor,
      eTrainingType: data.fields.eTrainingType,
    });

    setIsFinish(data.fields.eRequestStatus === requestStatus.completed);

    form.setFieldsValue({
      eReason: data.fields.eReason,
      ePhoneNumber: data.fields.ePhoneNumber,
      eDepartment: data.fields.eDepartment,
      eCourse: data.fields.eCourse,
      eMajor: data.fields.eMajor,
      eTrainingType: data.fields.eTrainingType,

      eIssueNumber: data.fields.eIssueNumber,
      eIssueTimes: data.fields.eIssueTimes,
      eIssueEffectiveDate: moment(data.fields.eIssueEffectiveDate),

      eCourseDate: [moment(data.fields.eCourseDate), moment(data.fields.eCourseDateEnd)],
    });
  };

  useEffect(() => {
    initialData();
  }, []);

  const confirmDelete = () => {
    const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
    if ((dataSource.length - listDelete.length) % 10 == 0) {
      if (currentPage >= 2 && currentPage === NUM_PAGES) setCurrentPage(currentPage - 1);
    }

    let newDataSource = [...dataSource];
    newDataSource = newDataSource.filter((value, index) => !listDelete.includes(index));
    setDataSource(newDataSource);
    setListDelete([]);
    setIsMultiDelete(false);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <>
      {loading && <Skeleton />}
      {!loading && (
        <Form onFinish={onFinish} size="large" form={form} onValuesChange={onValuesChange}>
          <Row gutter={[32, 0]}>
            <RenderHelper
              allValue={allValue}
              form={form}
              fields={formFields.map((value) => {
                if (value.field != "eDepartment") return value;
                return {
                  ...value,
                  disabled: true,
                };
              })}
              setAllValue={setAllValue}
              disabledAll={isFinish}
            />
            <Col span={12}>
              <StyledTitle level={5}>
                Chọn ngày <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item name="eCourseDate" rules={[{ required: true, message: "Chọn ngày" }]}>
                <RangePicker disabled={isFinish} style={{ width: "100%" }} placeholder={["Từ ngày", "Đến ngày"]} />
              </Form.Item>
            </Col>
          </Row>

          {isFinish && (
            <Row>
              <Col>
                <StyledTitle level={5}>Chi tiết</StyledTitle>
              </Col>
            </Row>
          )}

          {isFinish && (
            <Row>
              <Col>
                <CreateModal dataSource={dataSource} setDataSource={setDataSource} />
              </Col>

              <Col>
                {!isMultiDelete && (
                  <StyledButton
                    bgColor="red"
                    className="ml-3"
                    type="primary"
                    danger
                    onClick={() => setIsMultiDelete(true)}
                  >
                    Chọn nhiều để xóa
                  </StyledButton>
                )}

                {isMultiDelete && (
                  <StyledButton
                    className="ml-3"
                    bgColor="green"
                    onClick={() => {
                      setIsMultiDelete(false);
                      setListDelete([]);
                    }}
                  >
                    Quay lại
                  </StyledButton>
                )}

                {listDelete.length != 0 && (
                  <StyledButton
                    bgColor="red"
                    className="ml-3"
                    type="primary"
                    danger
                    onClick={() => {
                      showDeleteConfirm();
                    }}
                  >
                    Xóa dữ liệu đã chọn
                  </StyledButton>
                )}
              </Col>

              <Col>
                <Upload {...props}>
                  <StyledButton bgColor="blue" className="mx-3 ">
                    Tải biểu mẫu
                  </StyledButton>
                </Upload>
              </Col>

              <Col>
                <div className="mt-1">
                  <a href="#" className="text-primary" onClick={downLoad}>
                    Download biểu mẫu tại đây
                  </a>
                </div>
              </Col>
            </Row>
          )}

          {isFinish && (
            <div style={{ overflowX: "scroll" }}>
              <Table
                dataSource={dataSource}
                columns={columns}
                pagination={{
                  onChange: (page) => {
                    setCurrentPage(page);
                  },
                  current: currentPage,
                }}
              />
            </div>
          )}

          <Row gutter={[32, 0]}>
            <RenderHelper disabledAll={isFinish} fields={additionalFormFields} />
          </Row>

          <Row gutter={[32, 0]}>
            <Col span={24}>
              <div className="d-flex justify-content-center">
                <StyledButton
                  bgColor="red"
                  htmlType="submit"
                  onClick={() => history.push(Routes.summaryEmployeeRequestPage.path)}
                  danger
                  type="primary"
                >
                  Hủy
                </StyledButton>

                <StyledButton bgColor="yellow" type="primary" htmlType="submit" className="ml-3">
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
}
